<template>
  <div class="chat-container">
    
    <div class="chat-history">
      <div
        v-for="(message, index) in chatMessages"
        :key="index"
        class="message"
      >
        <div :class="['message-bubble', message.senderClass]">
          <span class="sender">{{ message.senderPrefix }}</span>
          {{ message.text }}
        </div>
      </div>
    </div>
    <div class="intro-message">
      Este es un chatBOT de ejemplo para DataCraft donde la asistente se llama
      'La Catita' y responderá sobre lo que ofrece DataCraft y con un tono de
      voz 'Cordobes, Argentina'
    </div>
    <input
      v-model="question"
      placeholder="Ingresa aquí tú consulta."
      class="input-box"
      @keyup.enter="submitQuestion"
    />
    <button @click="submitQuestion" class="chatbot-btn">chatBOT</button>
  </div>
</template>

<script>
import { askChatbot } from "../utils/chatBot";

export default {
  data() {
    return {
      question: "",
      chatHistory: [],
    };
  },
  computed: {
    chatMessages() {
      return this.chatHistory.map((message) => {
        const senderPrefix = message.sender === "Tú" ? "Tú:" : "chatBOT:";
        return {
          text: message.text,
          sender: message.sender,
          senderClass: message.sender === "Tú" ? "user" : "chatbot",
          senderPrefix: senderPrefix,
        };
      });
    },
  },
  methods: {
    async submitQuestion() {
      if (this.question.trim() === "") return;

      this.chatHistory.push({ text: this.question, sender: "Tú" });

      try {
        const answer = await askChatbot(this.question);
        this.chatHistory.push({ text: answer, sender: "ChatBOT" });
      } catch (error) {
        console.error("Error al obtener respuesta:", error);
        this.chatHistory.push({
          text: "Lo siento, hubo un error al obtener la respuesta.",
          sender: "ChatBOT",
        });
      }

      this.question = "";
    },
  },
};
</script>

<style scoped>
.chat-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80vw;
  padding: 20px 0;
  gap: 10px;
  background-color: var(--color-background);
  margin: auto;
}
h2 {
  color: var(--color-accent);
  font-family: var(--font-sans);
  font-size: 4rem;
  font-weight: bold;
  margin: 30px auto;
}
.chat-history {
  min-height: 300px;
  max-height: 80vh;
  border: 1px solid var(--color-accent);
  border-radius: 10px;
  overflow-y: auto;
  width: 80vw;
  padding: 10px;
  font-family: var(--font-sans);
}

.intro-message {
  width: 80vw;
  color: var(--color-accent); /* Puedes definir el color que desees */
  font-style: italic; /* Puedes aplicar estilo italic si lo prefieres */
  margin-bottom: 10px; /* Ajusta el espaciado según tus preferencias */
}

.message-bubble {
  border-radius: 15px;
  padding: 10px;
  margin: 5px 0;
  max-width: 100%;
  word-wrap: break-word;
  font-size: 1.5rem;
}

.user {
  background-color: var(--color-accent);
  color: var(--color-background);
  text-align: end;
}

.chatbot {
  background-color: var(--color-primary);
  color: var(--color-background);
  text-align: start;
}

.sender {
  font-weight: bold;
}

.input-box {
  width: 80vw;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid var(--color-accent);
  background-color: var(--color-background);
  color: var(--color-accent);
  font-family: var(--font-sans);
  font-size: 1.5rem;
  margin-top: 10px;
}

.input-box:focus {
  outline: 3px solid var(--color-primary);
}

.chatbot-btn {
  padding: 5px 15px;
  background-color: var(--color-accent);
  color: var(--color-background);
  font-family: var(--font-sans);
  font-weight: bold;
  font-size: 1.5rem;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 10px;
  width: 80vw;
}

.chatbot-btn:hover {
  background-color: var(--color-primary);
}
</style>
